<!-- eslint-disable @typescript-eslint/no-use-before-define -->
<template>
    <!-- 新增cron-->
    <vxe-modal
        v-model="formInput.isShow"
        :title="formInput.title"
        width="700"
        height="500"
        @close="closeReqEvent"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                :rules="formInput.formRules"
                title-align="right"
                ref="rForm"
                title-width="60"
            >
                <vxe-form-item
                    title="基本信息"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-address-card-o' }"
                ></vxe-form-item>
                <vxe-form-item
                    title="开发编号"
                    field="flow_name"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.flow_name"
                            placeholder="请输入开发编号"
                            clearable
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectReqs()"
                            :disabled="allInputDisable"
                            >选择</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="执行人"
                    field="create_name"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.create_name"
                            placeholder="请输入姓名"
                            readonly
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectUser(1)"
                            :disabled="
                                proxy.$store.state.isAdmin == '0' ||
                                formInput.allInputDisable
                            "
                            >选择</vxe-button
                        >
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="Cron表达式"
                    field="cron"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.cron"
                            placeholder="请输入Cron表达式"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" field="" span="14" title-width="120px">
                    <template #default
                        ><div style="font-size: 13px; color: blue">
                            <a
                                href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1733"
                                target="_blank"
                                >(分钟[0-59] 小时[0-23] 日期[1-31] 月份[1-12]
                                星期[MON-FRI])</a
                            >
                        </div></template
                    >
                </vxe-form-item>
                <vxe-form-item
                    title="项目根目录"
                    field="root"
                    span="24"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.root"
                            placeholder="请输入项目根目录"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="虚拟机"
                    field="machine_name"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.machine_name"
                            :options="macOptions"
                            placeholder="全部"
                            clearable
                            transfer
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="是否启用"
                    field="enabled"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.enabled"
                            placeholder="全部"
                            clearable
                            transfer
                        >
                            <vxe-option value="1" label="是"></vxe-option>
                            <vxe-option value="0" label="否"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="备注"
                    field="remark"
                    span="24"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.remark"
                            placeholder="请输入备注"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" field="" span="24" title-width="120px">
                    <template #default>
                        <div style="color: red">{{ cronDesc }}</div>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer>
            <div style="text-align: center; width: 100%">
                <vxe-button @click="save" icon="fa fa-save" status="success">
                    保存
                </vxe-button>
                <vxe-button
                    icon="fa fa-chevron-right"
                    @click="next_cron()"
                    status="primary"
                    >下一条
                </vxe-button>
                <vxe-button @click="closeModal()">关闭 </vxe-button>
            </div>
        </template>
    </vxe-modal>
    <!--选择流程-->
    <vxe-modal title="选择项目" v-model="isShowRequireSel" width="640">
        <template #default>
            <div>
                <vxe-form :data="reqTablePager">
                    <vxe-form-item
                        title="关键字"
                        field="searchKey"
                        :item-render="{}"
                    >
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入开发编号、项目名称"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findReqsData"
                                @keyup.enter="findReqsData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectReq"
                                >选择</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtReqs"
                    ref="xTableReqs"
                    height="300"
                    @cell-dblclick="confirmSelectReq"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="ProcessID"
                        title="开发编号"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="ProcessName"
                        title="项目名称"
                        width="180"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>

                    <vxe-column
                        field="CreateMan"
                        title="创建人"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="CreateManEmail"
                        title="创建人邮箱"
                        width="120"
                        sortable
                        show-overflow
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="PubState"
                        title="发布阶段"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="realPlatformName"
                        title="部署平台"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="MachineName"
                        title="虚拟机"
                        width="120"
                        sortable
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="reqTablePager.currentPage"
                    v-model:page-size="reqTablePager.pageSize"
                    :total="reqTablePager.totalResult"
                    @page-change="reqListPageChange"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
    <!--选择用户-->
    <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
        <template #default>
            <div>
                <vxe-form>
                    <vxe-form-item title="关键字" :item-render="{}">
                        <template #default>
                            <vxe-input
                                v-model="userTablePager.searchKey"
                                placeholder="请输入姓名或邮箱"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findUserData"
                                @keyup.enter="findUserData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectUser"
                                >确定</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item span="24">
                        <template #title>
                            <span>已选(</span
                            ><span style="color: red">双击选择</span
                            ><span>)</span>
                        </template>
                        <template #default>
                            <div>
                                <span
                                    v-if="formInput.formData.create_name != ''"
                                    >{{ formInput.formData.create_name }}({{
                                        formInput.formData.create_mail
                                    }})</span
                                >
                                <va-icon
                                    v-if="formInput.formData.create_name != ''"
                                    class="icon-left input-icon"
                                    @click="clearUser()"
                                    name="clear"
                                />
                            </div>
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtUser"
                    ref="xTableUser"
                    height="300"
                    @cell-dblclick="chooseUser"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="UserName"
                        title="姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobZb"
                        title="总部"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobName"
                        title="部门"
                        width="120"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="UserMail"
                        title="邮箱"
                        width="200"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="uid"
                        title="uid"
                        width="10"
                        :visible="false"
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="userTablePager.currentPage"
                    v-model:page-size="userTablePager.pageSize"
                    :total="userTablePager.totalResult"
                    @page-change="handlePageChangeUser"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineEmits,
    defineExpose,
    computed,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
import { isValidCron } from "cron-validator";
import cronstrue from "cronstrue/i18n";

const { proxy } = getCurrentInstance();

const formInput = reactive({
    title: "新增Cron",
    isShow: false,
    formData: {
        id: "",
        cron_id: "",
        flow_name: "",
        cron: "* * * * *",
        root: "D:/PyCodeEasyFlowFolder",
        create_mail: "",
        create_name: "",
        machine_name: "",
        enabled: "1",
        remark: "",
        saveButDisable: false,
        submitBtnDisable: false,
    },
    formRules: {
        cron_id: [{ required: false, message: "Cron ID不能为空" }],
        flow_name: [{ required: true, message: "开发编号不能为空" }],
        cron: [{ required: true, message: "Cron表达式不能为空" }],
        root: [{ required: true, message: "根路径不能为空" }],
        create_mail: [{ required: true, message: "执行人邮箱不能为空" }],
        create_name: [{ required: true, message: "执行人不能为空" }],
        machine_name: [{ required: true, message: "机器名称不能为空" }],
        enabled: [{ required: true, message: "启用状态不能为空" }],
    },
});

let allInputDisable = ref(false);
let editType = ref("1");
const xTableUser = ref(null);
const rForm = ref(null);
const macOptions = ref([]);
const emit = defineEmits(["flashList"]);
let dtReqs = ref([]); //需求列表
const isShowRequireSel = ref(false);
const openModal = async () => {
    formInput.formData = {
        id: "",
        cron_id: "",
        flow_name: "",
        cron: "* * * * *",
        root: "D:/PyCodeEasyFlowFolder",
        create_mail: "",
        create_name: "",
        machine_name: "",
        enabled: "1",
        remark: "",
    };

    formInput.title = "新增Cron";
    formInput.isShow = true;
    allInputDisable.value = false;
    editType.value = "1";
    const $rForm = rForm.value;

    try {
        if ($rForm) {
            await $rForm.reset();
        }
        // const re = await $rForm.clearValidate();
    } catch (e) {
        console.log(e);
    }
};
// 新增下一条
const next_cron = () => {
    editType.value = "1";
    formInput.formData.id = "";
    formInput.formData.cron = "* * * * *";
    formInput.formData.cron_id = "";
    formInput.formData.remark = "";
    formInput.title = "新增Cron";
};
const closeReqEvent = () => {
    emit("flashList");
};
let userSelectType = ref(1); //选择用户类型 0 创建人
let userTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
const reqTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
let iShowSelectUser = ref(false);

//选择用户 type 1 创建人
const selectUser = (type) => {
    userSelectType.value = type;
    userTablePager.searchKey = "";
    findUserData();
    iShowSelectUser.value = true;
};
const confirmSelectUser = () => {
    iShowSelectUser.value = false;
};
let dtUser = ref([]);
const closeModal = () => {
    formInput.isShow = false;
};
const findUserData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: userTablePager.currentPage,
        pageSize: userTablePager.pageSize,
        searchKey: [userTablePager.searchKey, ""],
    };
    proxy.$api.systemManageAPI
        .getUserList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtUser.value = res.data.Data.dataTable;
            userTablePager.currentPage = res.data.Data.currentPage;
            userTablePager.pageSize = res.data.Data.pageSize;
            userTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};

const chooseUser = () => {
    const $table = xTableUser.value;
    if (!$table) {
        console.error("表格实例未找到");
        return;
    }

    const record = $table.getCurrentRecord(); // 获取当前高亮行

    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    //判断是否已选择过
    if (formInput.formData.create_mail.toString() != "") {
        if (formInput.formData.create_mail == record.UserMail) {
            VXETable.modal.message({
                content: "该人员已选择",
                status: "warning",
            });
            return;
        }
    }

    formInput.formData.create_mail = record.UserMail;
    formInput.formData.create_name = record.UserName;
};

//删除用户
const clearUser = () => {
    formInput.formData.create_mail = "";
    formInput.formData.create_name = "";
};
const xTableReqs = ref(null);
const confirmSelectReq = () => {
    const $table = xTableReqs.value;
    const record = $table.getCurrentRecord();
    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }

    formInput.formData.flow_name = record.ProcessID;
    formInput.formData.create_mail = record.CreateManEmail;
    formInput.formData.create_name = record.CreateMan;
    formInput.formData.machine_name = record.MachineName;

    isShowRequireSel.value = false;
};
const findReqsData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: reqTablePager.currentPage,
        pageSize: reqTablePager.pageSize,
        searchKey: [reqTablePager.searchKey, "5"], //第1个参数
    };
    proxy.$api.psyManageAPI
        .getPublishList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            // console.log(res.data.Data);
            dtReqs.value = res.data.Data.dataTable;
            reqTablePager.currentPage = res.data.Data.currentPage;
            reqTablePager.pageSize = res.data.Data.pageSize;
            reqTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const selectReqs = () => {
    findReqsData();
    isShowRequireSel.value = true;
};
//保存新Cron
const save = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }

    const cron = formInput.formData.cron;
    if (cron == "* * * * *") {
        VXETable.modal.message({
            content: "Cron表达式非法",
            status: "error",
        });
        return;
    }
    const valid = isValidCron(cron, {
        seconds: false,
        alias: true,
        allowBlankDay: false,
        allowSevenAsSunday: true,
    });
    if (!valid) {
        VXETable.modal.message({
            content: "Cron表达式非法",
            status: "error",
        });
        return;
    }
    const params = getModel();

    if (formInput.formData.saveButDisable) {
        return;
    }

    //新增
    if (editType.value === "1") {
        proxy.$api.psyManageAPI
            .addRobotCron(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
                formInput.title = "编辑Cron";
                formInput.formData.id = res.data.Data;
                emit("flashList");
            })
            .catch((error) => {
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "2") {
        //更新
        proxy.$api.psyManageAPI
            .updateRobotCron(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
                emit("flashList");
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};
const getModel = () => {
    const cron = {
        id: formInput.formData.id,
        cron_id: formInput.formData.cron_id,
        flow_name: formInput.formData.flow_name,
        cron: formInput.formData.cron,
        root: formInput.formData.root,
        create_mail: formInput.formData.create_mail,
        create_name: formInput.formData.create_name,
        machine_name: formInput.formData.machine_name,
        enabled: formInput.formData.enabled,
        creator: proxy.$store.state.userID,
        modifer: proxy.$store.state.userID,
        remark: formInput.formData.remark,
    };
    return cron;
};
let submitLoading = ref(false);

const handlePageChangeUser = () => {
    findUserData();
};
const reqListPageChange = () => {
    findReqsData();
};
// type 1 新增 2 编辑
const editEvent = async (row) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.id],
    };
    proxy.$api.psyManageAPI
        .getRobotCronOne(Qs.stringify(params))
        .then(async (res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.formData = res.data.Data;
            formInput.formData.enabled = formInput.formData.enabled.toString();
            formInput.title = "编辑Cron";
            allInputDisable.value = false;

            editType.value = "2"; //更新

            formInput.isShow = true;
            const $rForm = rForm.value;
            try {
                if ($rForm) {
                    await $rForm.reset();
                }
                // const re = await $rForm.clearValidate();
            } catch (e) {
                console.log(e);
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const bindPC = () => {
    proxy.$api.systemManageAPI
        .getMachineListPsy()
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            // console.log(res.data.Data);
            macOptions.value = [];
            for (const item of res.data.Data) {
                macOptions.value.push({
                    value: item.PcName,
                    label: item.Abbr,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
onMounted(() => {
    setTimeout(() => {
        bindPC();
    }, 10);
});
const getCronText = (cron) => {
    try {
        let text = cronstrue.toString(cron, {
            locale: "zh_CN",
        });

        const arr = cron.trim().split(/\s+/);

        // 5位 cron:
        // 分 时 日 月 星期

        const day = arr[2];
        const month = arr[3];
        const week = arr[4];

        // 判断是否每天
        const isEveryDay = day === "*" && month === "*" && week === "*";

        if (isEveryDay) {
            text = "每天 " + text;
        }

        return text;
    } catch (e) {
        return cron;
    }
};
const cronDesc = computed(() => {
    const cron = formInput.formData.cron;

    if (!cron) {
        return "";
    }

    const value = cron.trim();

    // 强制 5 位
    if (value.split(/\s+/).length !== 5) {
        return "Cron表达式格式不正确";
    }

    const valid = isValidCron(value, {
        seconds: false,
        alias: true,
        allowBlankDay: false,
        allowSevenAsSunday: true,
    });

    if (!valid) {
        return "Cron表达式不合法";
    }

    return getCronText(value);
});

defineExpose({ openModal, editEvent });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
